import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmApiSurveyRecipientsError extends TmApiValidationError {
  public name = 'TmApiSurveyRecipientsError'
}
